<template>
	<Modal @close="$emit('close')" class="copy-board" size="small">
		<div class="container">
			<div class="row">
				<div class="col-12 text-center">
					<h3>Copy Board</h3>
				</div>
			</div>
			<div class="row">
				<div class="picker col-12">
					<span>Choose previous board date</span>
					<datepicker class="datepicker-input" :inline="true" v-model="date"/>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-center">
					<button class="button-action button-submit" @click="$emit('copy', date)">COPY BOARD</button>
				</div>
			</div>
		</div>
	</Modal>
</template>

<script>
import Modal from './../Modal.vue'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
  components: {
		Modal,
		Datepicker
	},
	data() {
		return {
			date: ''
		}
	},
	mounted() {
		this.date = moment().format('D MMM YYYY')
	}
}
</script>

<style lang="scss">
.copy-board {
	text-align: center;
	.modal-body {
		min-height: 350px;
	}
	input {
		border: 1px solid #0C2D39;
	}
	.picker {
		margin-bottom: 20px;
		>div {
			margin-top: 20px;

		}
	}
	.datepicker-input {
		.vdp-datepicker__calendar {
			margin: 0 auto;
		}
		header {
			color: black !important;
			background-color: white !important;
			.next,
			.prev {
				display: inline;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Board/Copy.vue